<script context="module">
  export interface ISubMenuItem {
    isActive: boolean;
    title: string;
    url: string;
  }
</script>

<script>
  import TwoColumns from "../TwoColumns.svelte";
  import type { IPageData } from "../../../core/types";
  import { t } from "../../../core";
  import LeftNav from "./LeftNav.svelte";

  interface IConstructionPage extends IPageData {
    subMenu: ISubMenuItem[];
  }

  export let data: IConstructionPage;
</script>

<TwoColumns>
  <div class="g-centered">
    <h1 class="title">{t("ConstructionProcess.LeftNavigation.Title")}</h1>
    <h1 class="subtitle">{data.title}</h1>
  </div>

  <slot />

  <div slot="aside">
    <LeftNav items={data.subMenu} />
  </div>
</TwoColumns>

<style lang="scss">
  .title {
    @include h1;
    margin-bottom: 30px;
  }

  .subtitle {
    @include h2;
    margin-bottom: 30px;
  }
</style>
